<template>
  <Transition
    :appear="null"
    :css="null"
    @before-enter="beforeEnter"
    @enter="enter"
    @after-enter="afterEnter"
    @before-leave="beforeLeave"
    @leave="leave"
  >
    <slot/>
  </Transition>
</template>

<script setup>
  import { setTimeout } from '@/utils/global';

  function beforeEnter(el) {
    if (el?.firstElementChild) {
      el.firstElementChild.classList.add('floating-enter-active');
      el.lastElementChild.classList.add('floating-enter-active');
    }
  }

  function enter(el, done) {
    setTimeout(done, 100);
  }

  function afterEnter(el) {
    el.firstElementChild.classList.remove('floating-enter-active');
    el.lastElementChild.classList.remove('floating-enter-active');
  }

  function beforeLeave(el) {
    el.firstElementChild.classList.add('floating-leave-active');
    el.lastElementChild.classList.add('floating-leave-active');
  }

  function leave(el, done) {
    setTimeout(() => {
      done();
    }, 100);
  }
</script>
